import Vue from 'vue'
import store from '@/store'
/**
 * 操作权限
 * v-permission可直接控制模块是否显示
 * 全局方法$permission返回是否显示true/false
 */
Vue.directive('permission', {
    bind: function (el, binding, vnode) {
        if (!Vue.prototype.$hasPermission(binding.value)) {
            el.remove()
        }
    }
})
// 防多次点击,重复
Vue.directive('preventReClick', {
    inserted (el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 5000)
            }
        })
    }
})

Vue.prototype.$hasPermission = function (value) {
    let perms

    switch (typeof value) {
        case 'string':
            perms = [value]
            break
        case 'object':
            if (value instanceof Array) {
                perms = value
            }
            break

        default:
            perms = []
            break
    }

    const storePerms = store.state.user.nowPower
    let has = perms.every(item => {
        // console.log('itemaaaa', item)
        return storePerms.includes(item)
    })
    // console.log('has', has)
    return has
}
Vue.prototype.$notPerm = function (value) {
    return !Vue.prototype.$hasPermission(value)
}
